import { GameProfile } from '@libs/shared/src/api/GameProfileApi/GameProfileApi.schema';
import { Text } from 'src/utils/types/gameObjects';

import { IconAssets } from '../../utils/enums/assets';
import { BreackpointsX, BreackpointsY } from '../../utils/enums/breackpoints';

import { UIController } from './uiController';

type TopPlayerText = {
  score: Text | null;
  name: Text | null;
};

export type TopPlayersUi = {
  first: TopPlayerText;
  second: TopPlayerText;
  third: TopPlayerText;
};

export class UiComponents {
  static TopPlayers(context: Phaser.Scene & { topPlayers: GameProfile[] }): TopPlayersUi {
    const { y, x, scoreTextStyle, nameTextStyle } = UiComponents.prototype.topPlayersPos(context);

    const players: TopPlayersUi = {
      first: { score: null, name: null },
      second: { score: null, name: null },
      third: { score: null, name: null },
    };

    const addPlayerTexts = (player: GameProfile | undefined, posY: number) => {
      return {
        score: context.add
          .text(x.text, posY - y.textOffset, player?.highScore?.toString() ?? '...', scoreTextStyle)
          .setOrigin(0, 0.5),
        name: context.add
          .text(x.text, posY + y.textOffset, player?.user.name ?? '...', nameTextStyle)
          .setOrigin(0, 0.5),
      };
    };

    const [p1, p2, p3] = context.topPlayers;

    players.first = addPlayerTexts(p1, y.first);
    players.second = addPlayerTexts(p2, y.second);
    players.third = addPlayerTexts(p3, y.third);

    return players;
  }

  static updateTopPlayers(
    uiComponent: TopPlayersUi,
    topPlayers: GameProfile[],
    context: Phaser.Scene & { topPlayers: GameProfile[] }
  ) {
    const { y, x, imgScale } = UiComponents.prototype.topPlayersPos(context);
    const [p1, p2, p3] = topPlayers;

    const updateText = (textObj: Text | null, content: string | undefined) => {
      if (textObj && content !== undefined) {
        textObj.setText(content);
      }
    };

    updateText(uiComponent.first.score, p1?.highScore?.toString());
    updateText(uiComponent.first.name, p1?.user.name);
    updateText(uiComponent.second.score, p2?.highScore?.toString());
    updateText(uiComponent.second.name, p2?.user.name);
    updateText(uiComponent.third.score, p3?.highScore?.toString());
    updateText(uiComponent.third.name, p3?.user.name);

    [p1, p2, p3].forEach((player, idx) => {
      if (player) {
        const positions = [y.first, y.second, y.third];
        context.add.image(x.img, positions[idx], IconAssets.AVATAR_ICON).setScale(imgScale);
      }
    });
  }

  topPlayersPos(context: Phaser.Scene) {
    const [w, h] = UIController.widthHeight(context);
    const [x, y] = UIController.centerXY(context);

    let imgScale = 1;

    const posX = {
      img: x - 70,
      text: x - 10,
    };

    const posY = {
      first: y - 120,
      second: y - 20,
      third: y + 80,
      textOffset: 15,
    };

    const scoreTextStyle = {
      fontSize: '24px',
      color: UIController.textColor(),
      fontFamily: "'Press Start 2P', 'cursive'",
    };

    const nameTextStyle = {
      fontSize: '18px',
      color: UIController.textColor(),
      fontFamily: "'Press Start 2P', 'cursive'",
    };

    if (w <= BreackpointsX.LAPTOP || h <= BreackpointsY.LG) {
      imgScale = 0.75;
      posX.text = x - 20;

      scoreTextStyle.fontSize = '18px';
      nameTextStyle.fontSize = '14px';

      posY.first = y - 100;
      posY.third = y + 60;
      posY.textOffset = 13;
    }

    return {
      x: posX,
      y: posY,
      imgScale,
      scoreTextStyle,
      nameTextStyle,
    };
  }
}
